/** Small deterministic PRNG (mulberry32) so test signals and test vectors are reproducible. */
export class Rng {
  private s: number;
  private spare: number | null = null;
  constructor(seed = 1) {
    this.s = seed >>> 0;
  }
  /** uniform in [0, 1) */
  next(): number {
    let t = (this.s = (this.s + 0x6d2b79f5) >>> 0);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  /** uniform in [-1, 1) */
  bipolar(): number {
    return 2 * this.next() - 1;
  }
  /** standard normal (Box–Muller) */
  gauss(): number {
    if (this.spare !== null) {
      const v = this.spare;
      this.spare = null;
      return v;
    }
    let u = 0;
    while (u === 0) u = this.next();
    const v = this.next();
    const r = Math.sqrt(-2 * Math.log(u));
    this.spare = r * Math.sin(2 * Math.PI * v);
    return r * Math.cos(2 * Math.PI * v);
  }
}

export function randomSignal(n: number, seed = 1): Float32Array {
  const r = new Rng(seed);
  const x = new Float32Array(n);
  for (let i = 0; i < n; i++) x[i] = r.bipolar();
  return x;
}
